<template>
  <main>
    <div class="common-report qtime-activity-view">
      <div>
        <div>
          <qtime-report-header></qtime-report-header>
          <location-overview-relation></location-overview-relation>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import LocationOverviewRelation from "./location-overview/LocationOverviewRelation";
const QtimeReportHeader = () => import("./QtimeReportHeader");
export default {
  name: "LocationOverview",
  components: { LocationOverviewRelation, QtimeReportHeader },
  computed: {
    // filter: function() {
    //   return this.$store.state.reports.qcentrisCountryTurnoverFilter;
    // }
  },
  beforeMount() {
    //this.fetchData();
  },
  methods: {
    // fetchData: function() {
    //   this.$store.dispatch("fetchCountryTurnover", this.filter);
    //   this.$store.dispatch("fetchReportAggregates");
    // }
  }
};
</script>

<style scoped>
.qtime-activity-view {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
</style>